import React from 'react'
import projectImg from "../assets/Todo.png"


export default function({img= projectImg, title= "Project name", desc= "ABC", link= link}) {
    return (
        <div>
            <div className="projectItem_img">
                <a href={link} target="_blank">
                    <img className="single_img" src={img} alt="project image" /> 
                </a>      
            </div>
            <div className="projectItem_info">
                <h3 className="projectItem_title">{title}</h3>
                <p className="projectItem_desc">{desc}</p>
            </div>
        </div>
    )
}
